import type { DdqSession } from '@/types/api.types';

export type SessionSortOption = 'priority' | 'newest' | 'oldest' | 'automation' | 'name';

const PRIORITY_ORDER: Record<string, number> = {
  high: 0,
  normal: 1,
  low: 2,
};

/**
 * Sort sessions by the specified option
 */
export function sortSessions(
  sessions: DdqSession[],
  sortBy: SessionSortOption
): DdqSession[] {
  const sorted = [...sessions];

  switch (sortBy) {
    case 'priority':
      return sorted.sort((a, b) => {
        const aPriority = (a as DdqSession & { priority?: string }).priority || 'normal';
        const bPriority = (b as DdqSession & { priority?: string }).priority || 'normal';
        const priorityDiff = (PRIORITY_ORDER[aPriority] ?? 1) - (PRIORITY_ORDER[bPriority] ?? 1);
        if (priorityDiff !== 0) return priorityDiff;
        // Within same priority, sort by newest first
        return new Date(b.created).getTime() - new Date(a.created).getTime();
      });
    case 'newest':
      return sorted.sort(
        (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
      );
    case 'oldest':
      return sorted.sort(
        (a, b) => new Date(a.created).getTime() - new Date(b.created).getTime()
      );
    case 'automation':
      return sorted.sort((a, b) => b.automationRate - a.automationRate);
    case 'name':
      return sorted.sort((a, b) =>
        a.fileName.localeCompare(b.fileName, undefined, { sensitivity: 'base' })
      );
    default:
      return sorted;
  }
}
